<router-outlet (activate)="onActivate()"></router-outlet>
<app-back-to-top-button></app-back-to-top-button>
<simple-notifications></simple-notifications>
